export const TRUE = 1;
export const FALSE = 0;

export const BOOL_TRUE = true;
export const BOOL_FALSE = false;